import {
	GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS,
	GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS_SUCCESS,
	GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS_FAIL,
	GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS_RESET,
} from '../actions/getInsuranceCompaniesFilingStatusCountsAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getInsuranceCompaniesFilingStatusCountsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_INSURANCE_COMPANIES_FILING_STATUS_COUNTS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getInsuranceCompaniesFilingStatusCountsReducer;
